let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dj10i")).then(() => parcelRequire('lRxDt'));